import '@justinribeiro/lite-youtube';
import '../css/RoundedVideo.css';
import { useState, useRef, useEffect } from "react";
import { Flex, Button } from "antd";
import { useQuery } from "@apollo/client";
import { getFromLocalStorage, saveToLocalStorage } from "../utils/localStorage";
import {
    GET_VIDEO_BY_SLUG,
} from "../queries";
import useIsMobile from '../utils/isMobile';

const RoundedVideo = ({ page, section, lang }) => {
  const slug = `${page}-${section}-${lang}`;
  const [sectionData, setSectionData] = useState(() => {
    const cachedData = getFromLocalStorage(page);
    return cachedData?.sections?.[slug] || null;
  });
  const [iframeLoaded, setIframeLoaded] = useState(false);

  const videoRef = useRef(null);
  const [loadIframe, setLoadIframe] = useState(false);
  const isMobile = useIsMobile();

  const { loading, error } = useQuery(GET_VIDEO_BY_SLUG, {
    variables: { slug },
    skip: !!sectionData,
    onCompleted: (fetchedData) => {
      const postData = fetchedData.sectionsBy?.video;
      const dataToLocal = {
        ...sectionData,
        sections: {
          [slug]: postData,
        },
      };
      saveToLocalStorage(page, dataToLocal);
      setSectionData(postData);
    },
  });

  useEffect(() => {
    if (sectionData?.videoUrl && videoRef.current) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setLoadIframe(true);
            observer.disconnect();
          }
        },
        { threshold: 0.25 }
      );
      observer.observe(videoRef.current);
      return () => observer.disconnect();
    }
  }, [sectionData?.videoUrl]);

  // Extraer el videoId de la URL
  const extractVideoId = (url) => {
    const match = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([^\?&]+)/);
    return match ? match[1] : null;
  };

  const videoId = sectionData?.videoUrl ? extractVideoId(sectionData.videoUrl) : null;

  return (
    <>
      {sectionData && (
        <Flex className="RoundedVideo">
          <Flex className="RoundedVideo-title">
            <Flex>
              <h2
                className="h4-headline-500"
                dangerouslySetInnerHTML={{ __html: sectionData?.tituloVideo }}
              />
            </Flex>
            {sectionData?.enlace?.url && (
              <Button 
                className="bt-medium-500" 
                style={{ color: '#0027F9' }} 
                type="link" 
                href={sectionData?.enlace?.url || '#'} 
                variant="link">
                  {sectionData?.enlace?.title || 'Get Started'}
              </Button>
            )}
          </Flex>

          <Flex ref={videoRef} className="RoundedVideo-video">
            {videoId && (
              <>
                <lite-youtube
                  class={iframeLoaded ? 'hidden' : ''}
                  videoid={videoId}
                  params={`${isMobile ? "controls=0&" : ""}`}
                ></lite-youtube>

                {loadIframe && (
                  <iframe
                    className={`rounded-video-iframe ${iframeLoaded ? 'loaded' : ''}`}
                    width="100%"
                    height="100%"
                    src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&controls=${isMobile ? 0 : 1}&playsinline=1`}
                    frameBorder="0"
                    allow="autoplay; encrypted-media"
                    allowFullScreen
                    onLoad={() => setIframeLoaded(true)}
                  />
                )}
              </>
            )}
          </Flex>
        </Flex>
      )}
    </>
  );
};

export default RoundedVideo;
